"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputText = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const helpers_1 = require("evolution-common/lib/utils/helpers");
const InputText = (props) => (react_1.default.createElement("textarea", { autoComplete: "off", rows: props.widgetConfig.rows || 5, className: 'apptr__form-input input-text', name: props.widgetConfig.shortname, id: props.id, defaultValue: (0, LodashExtensions_1._isBlank)(props.value)
        ? (0, helpers_1.parseString)(props.widgetConfig.defaultValue, props.interview, props.path, props.user)
        : props.value, onBlur: props.onValueChange, ref: props.inputRef, maxLength: props.widgetConfig.maxLength || 2000 }));
exports.InputText = InputText;
exports.default = exports.InputText;
//# sourceMappingURL=InputText.js.map